<template>
  <div class="receptionOverflow">
    <div class="flex">
      <div class="commonTitle">
        <h1>顾客信息</h1>
      </div>
      <el-form ref="ruleForm" style="margin: 30px 0 0 0;" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="手机号码：" prop="phone" required>
          <el-input v-model.trim="form.phone" class="width_200" placeholder="请输入手机号码" :maxlength="11" @keyup.enter.native="Lib.keyboardBlur"></el-input>
        </el-form-item>
        <el-form-item label="顾客姓名：" prop="name" required>
          <el-input v-model.trim="form.name" class="width_200" placeholder="请输入顾客姓名" :maxlength="15" @keyup.enter.native="Lib.keyboardBlur"></el-input>
        </el-form-item>
        <el-form-item label="备注说明：" prop="desc">
          <el-input v-model="form.desc" class="textarea_one" placeholder="100个字符以内" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div class="commonTitle">
        <h2>预约信息</h2>
      </div>
      <el-form ref="form" style="margin: 30px 0;" :model="form" label-width="100px">
        <el-form-item label="选择日期：" required>
          <el-date-picker v-model="form.date" class="width_200" align="right" type="date" placeholder="选择日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" :editable="false" @change="chooseDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择大项：" required>
          <el-select v-model="form.chooseBigItem" class="width_200" placeholder="选择大项" @change="chooseBigItem('')">
            <el-option v-for="item in form.bigItemList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span class="span_one">选择小项：</span>
          <el-select v-model="form.chooseSmallItem" class="input_s200" placeholder="选择小项" @change="chooseSmallItem">
            <el-option v-for="item in form.smallItemList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span class="span_one">查询{{ Lib.collectively() }}：</span>
          <el-input v-model.trim="form.search" class="input_s200" :placeholder="'查询'+Lib.collectively()" @keyup.enter.native="search">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="search"></i>
          </el-input>
        </el-form-item>
        <el-form-item v-for="(item,index) in form.list" :key="index" class="jsList" :label="item.technicianName+'：'">
          <!--<div class="timeList" :style="'height:' + showHeight">-->
          <div class="timeList" :style="chooseTimeIndex == index ? 'height: auto;' : 'height: 40px;'">
            <ul>
              <li v-for="(time,v) in item.technicianClassItems" :id="item.technicianId+''+v" :key="v" :class="time.isOrder == 0 ? '' : 'disabled'" @click="chooseTime(item.technicianId,time.timeStart,time.timeEnd,v,time.isOrder)">
                <i class="iconfont">&#xe60a;</i>
                <span>{{ time.timeStart }}</span>
                <span>至</span>
                <span>{{ time.timeEnd }}</span>
              </li>
            </ul>
          </div>
          <p v-if="chooseTimeIndex == index" class="themeFC" style="text-align: center;width: 200px;margin: 0 auto;cursor: pointer;" @click="lookTimeMore(index)">∧ 收起</p>
          <p v-else class="themeFC" style="text-align: center;width: 200px;margin: 0 auto;cursor: pointer;" @click="lookTimeMore(index)">∨ 查看更多</p>
        </el-form-item>
        <el-form-item>
          <el-button :disabled="submitBtn" type="primary" @click="onSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getItemLIst, postTechnicianOrderList, postSaveBookOrder, getItemTypeLIst, getMemberCardMsg, getBilling4Book
} from '../api';

let newSetTime;
export default {
  data() {
    const checkPhone = (rule, value, callback) => {
      clearTimeout(newSetTime);
      if (value === '') {
        callback(new Error('请输入手机号码'));
      } else if (this.Lib.CheckPhone(value) == false) {
        if (value.length == 11) {
          callback(new Error('请输入正确的手机号码!'));
        } else {
          newSetTime = setTimeout(() => {
            callback(new Error('请输入正确的手机号码!'));
          }, 1000);
        }
      } else {
        this.memberSearch();
        callback();
      }
    };
    return {
      pickerOptions: { // 新增预约选择时间限制--不能选择今天之前的日期
        disabledDate(time) {
          return Date.now() > (time.getTime() + 3600 * 1000 * 24);
        }
      },
      showHeight: '100px', // 可预约统称时间段--隐藏高度
      submitBtn: false, // 提交按钮状态
      form: { // 提交表单数据
        phone: '',
        name: '',
        desc: '', // 备注
        date: '', // 时间
        bigItemList: [], // 大项列表
        chooseBigItem: '', // 选择的大项
        smallItemList: [], // 小项列表
        chooseSmallItem: '', // 选择的小项
        search: '', // 搜索值--搜索统称
        technicianId: '', // 预约的统称ID（修改用到）
        timeStart: '', // 预约的开始时间（修改用到）
        timeEnd: '', // 预约的结束时间（修改用到）
        list: [] // 可预约统称列表
      },
      rules: {
        phone: [
          { required: true, validator: checkPhone, trigger: 'change' },
          { required: true, validator: checkPhone, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入顾客姓名', trigger: 'change' },
          { required: true, message: '请输入顾客姓名', trigger: 'blur' }
        ]
      },
      chooseTimeList: {}, // 选择的预约时间段
      chooseTimeIndex: '-1', // 选择时间与否  -1为没有选择
      bespeakId: '', // 修改预约信息ID
    };
  },
  watch: {
    // 'form.phone'(val) {
    //     if (val.length == 11) {
    //         if (this.Lib.CheckPhone(val) == false) {
    //             this.$message('请输入正确的手机号码')
    //             return
    //         }
    //         this.memberSearch()
    //     }
    // }
  },
  activated() {
    this.bespeakId = window.sessionStorage.bespeakId;
    this.getBigItemList();
    if (this.bespeakId) {
      this.getEditBespeakInfo(this.bespeakId);
      this.chooseTimeIndex = '-1';
    } else {
      this.$refs.ruleForm.resetFields();
      Object.assign(this.$data.form, this.$options.data().form);
    }
  },
  methods: {
    // 搜索获取会员信息
    memberSearch() {
      const data = {
        keyWord: this.form.phone
      };
      getMemberCardMsg(data).then((res) => {
        if (res.data) {
          this.form.name = res.data.nickName;
        }
      });
    },
    // 查询统称
    search() {
      this.Lib.keyboardBlur();
      if (this.checkChoose() == true) {
        this.chooseSmallItem();
      }
    },
    // 展开/收起更多可预约时间
    lookTimeMore(index) {
      if (this.chooseTimeIndex == index) {
        this.chooseTimeIndex = '-1';
      } else {
        this.chooseTimeIndex = index;
      }
    },
    // 检查选择时间，项目与否
    checkChoose() {
      if (!this.form.date) {
        this.$message('请选择预约时间');
        return false;
      } if (!this.form.bigItemList) {
        this.$message('请选择项目');
        return false;
      } if (!this.form.chooseSmallItem) {
        this.$message('请选择项目');
        return false;
      }
      return true;
    },
    // 选择日期
    chooseDate() {
      if (!this.form.date) {
        this.form.chooseBigItem = '';
        this.form.chooseSmallItem = '';
        this.chooseTimeList = {};
        $('.jsList li').removeClass('timeHover');
        this.form.list = [];
      } else {
        this.chooseSmallItem();
      }
    },
    // 选择大项
    chooseBigItem(id) {
      this.form.chooseSmallItem = '';
      this.chooseTimeList = {};
      $('.jsList li').removeClass('timeHover');
      this.form.list = [];
      const data = {
        typeId: this.form.chooseBigItem
      };
      getItemLIst(data).then((res) => {
        this.form.smallItemList = res.data;
        if (id) {
          this.form.chooseSmallItem = id;
          this.chooseSmallItem();
        }
      });
    },
    // 选择小项
    chooseSmallItem() {
      if (this.checkChoose() == true) {
        this.chooseTimeList = {};
        $('.jsList li').removeClass('timeHover');
        this.form.list = [];
        const data = {
          date: this.form.date ? this.form.date : '',
          itemId: this.form.chooseSmallItem,
          keyWord: this.form.search,
          mainId: window.sessionStorage.mainId
        };
        postTechnicianOrderList(data).then((res) => {
          if (res.data.length > 0) {
            this.form.list = res.data;
            if (this.bespeakId) {
              res.data.forEach((item1, index1) => {
                if (item1.technicianId == this.form.technicianId) {
                  this.lookTimeMore(index1);
                  item1.technicianClassItems.forEach((item2, index2) => {
                    if (item2.timeStart == (`${this.form.timeStart}:00`)) {
                      item2.isOrder = 0;
                      setTimeout(() => {
                        this.chooseTime(item1.technicianId, item2.timeStart, item2.timeEnd, index2, 0);
                      }, 10);
                    }
                  });
                }
              });
            }
          } else {
            this.$message(`该项目没有可预约${this.Lib.collectively()}`);
          }
        });
      }
    },
    // 选择可预约时间段
    chooseTime(id, startTime, endTime, index, status) {
      const vm = this;
      if (status == 1) {
        vm.$message('该时间段已被预约');
        return;
      } if (status == -1) {
        vm.$message('该时间段已过期');
        return;
      }
      $('.jsList li').removeClass('timeHover');
      $(`#${id}${index}`).addClass('timeHover');
      vm.chooseTimeList.technicianId = id;
      vm.chooseTimeList.timeStart = `${vm.form.date} ${startTime}`;
      vm.chooseTimeList.timeEnd = `${vm.form.date} ${endTime}`;
    },
    // 提交数据
    onSubmit() {
      const vm = this;
      vm.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return false;
        }
      });
      if (!vm.form.phone) {
        return;
      }
      if (!vm.form.name) {
        return;
      }
      if (vm.checkChoose() == true) {
        if (!vm.chooseTimeList.technicianId) {
          vm.$message('请选择预约时间段');
        } else {
          vm.chooseTimeList.id = this.bespeakId;
          vm.chooseTimeList.itemId = vm.form.chooseSmallItem;
          vm.chooseTimeList.memberName = vm.form.name;
          vm.chooseTimeList.phone = vm.form.phone;
          vm.chooseTimeList.remark = vm.form.desc;
          vm.submitBtn = true;
          const data = vm.chooseTimeList;
          postSaveBookOrder(data).then((res) => {
            if (res.code == 0) {
              if (this.bespeakId) {
                vm.$message({ message: '修改成功', type: 'success' });
              } else {
                vm.$message({ message: '预约成功', type: 'success' });
              }
              window.sessionStorage.addRevation = '1';
              vm.$store.commit('deleteTabs', 'stage-addReservationList');
              vm.$router.push({
                name: 'stage-reservationList'
              });
            } else {
              vm.$message(res.msg);
            }
            vm.submitBtn = false;
          });
        }
      }
    },
    // 获取大项列表
    getBigItemList() {
      const data = {};
      getItemTypeLIst(data).then((res) => {
        this.form.bigItemList = res.data;
      });
    },
    // 获取修改信息
    getEditBespeakInfo(id) {
      const data = { orderId: id };
      getBilling4Book(data).then((res) => {
        this.form.phone = res.data.phone;
        this.form.name = res.data.memberName;
        this.form.desc = res.data.remark;
        this.form.date = res.data.date;
        this.form.technicianId = res.data.technicianId;
        this.form.timeStart = res.data.timeStart;
        this.form.timeEnd = res.data.timeEnd;
        this.form.chooseBigItem = res.data.itemTypeId;
        this.chooseBigItem(res.data.itemId);
      });
    }
  }
};
</script>

<style>
.timeList {
    padding: 20px 30px;
    border: 1px solid #d8dce5;
    border-radius: 5px;
    overflow: hidden;
}
.timeList ul {
    width: 100%;
    list-style-type: none;
}
.timeList ul li {
    width: 300px;
    border: 1px solid #d8dce5;
    border-radius: 5px;
    float: left;
    margin: 0 20px 20px 0;
    height: 38px;
    cursor: pointer;
}
.timeList ul .disabled {
    border: 1px solid #999 !important;
    color: #fff !important;
    background-color: #999;
}
.timeList ul:after {
    content: '';
    display: table;
    clear: both;
}
.timeList ul li .iconfont {
    font-family: 'iconfont' !important;
    font-size: 18px;
    font-style: normal;
    font-weight: 100 !important;
    color: #dbdee7;
    padding: 0 0 0 11px;
    position: relative;
    top: 1px;
}
.timeList ul li span {
    padding-left: 35px;
}
.textarea_one {
    margin-top: 15px;
}
</style>
